import {Component, OnDestroy, OnInit} from '@angular/core';
import {TourApiService} from '../services/tour-api.service';
import {TourService} from '../services/tour.service';
import {FeedbackInfo} from '../model/feedback-info';
import {EnumAware} from '../decorators/enum-aware.decorator';
import {ModalService} from '../services/modal.service';
import {Award} from '../model/award';
import {Subscription} from 'rxjs/Subscription';
import {TrackingService} from '../services/tracking.service';
import {Observable} from 'rxjs/Rx';
import {ReviewsOverview} from '../model/reviews-overview';
import {SurveyApiService} from '../services/survey-api.service';
import {SurveyQuery, SurveyQueryPage} from '../model/survey-query';
import {Survey, ToggleableFields} from '../model/survey';

@Component({
  selector: 'gt-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
@EnumAware
export class FeedbackComponent implements OnInit, OnDestroy {

  info: FeedbackInfo;
  overview: ReviewsOverview;
  query: SurveyQuery;
  private subscription: Subscription;
  private overviewSubscription: Subscription;
  private surveysLoadedSubscription: Subscription;
  award: Award;
  private awardIndex = 0;
  fetchingSurveys = false;

  constructor(public tourApiService: TourApiService,
              public surveyApiService: SurveyApiService,
              public modalService: ModalService,
              public tourService: TourService,
              private trackingService: TrackingService) { }

  ngOnInit() {
    this.info = this.tourService.tour.feedbackInfo;
    this.overview = this.surveyApiService.reviewsOverview;
    this.query = this.surveyApiService.surveyQuery;
    if (this.info.awards.length > 0) {
      this.award = this.info.awards[this.awardIndex];
      const timer: any = Observable.timer(5000, 5000);
      this.subscription = timer.subscribe(t => {
        this.rotateAward();
      });
      this.tourService.setDocumentTitleWithTour(this.tourService.tourFeatureTitle('feedback'));
      this.trackingService.trackAction(TrackingService.kActionRatings, null, 0);
    }
    // if the URL was accessed directly (eg: /builder/model/feedback) the async call to
    // get the overview data may take a bit.  Subscribe for the load event and update
    if (this.overview == null) {
      this.overviewSubscription = this.surveyApiService.reviewsOverviewLoaded.subscribe(
        (loaded: boolean) => {
          this.overview = this.surveyApiService.reviewsOverview;
        }
      );
    }
    this.surveysLoadedSubscription = this.surveyApiService.surveyListLoaded.subscribe(
      (loaded: boolean) => {
        this.fetchingSurveys = false;
      }
    );
  }

  showResults(pageType: SurveyQueryPage) {
    this.surveyApiService.fetchSurveyList(this.query.urlForPageType(pageType));
  }

  sortChanged() {
    this.fetchingSurveys = true;
    // this.query.resultSkip = 0;
    this.surveyApiService.fetchSurveyList(null);
  }

  rotateAward() {
    const nextIndex = this.awardIndex + 1;
    this.awardIndex = (nextIndex < this.info.awards.length) ? nextIndex : 0;
    this.award = this.info.awards[this.awardIndex];
  }

  toggleText(survey: Survey, field: ToggleableFields) {
    survey.toggleText(field);
  }

  feedbackDetailCSS() {
    return (this.info.awards.length > 0 ||  this.info.testimonials.length > 0) ? 'feedback-detail' : 'feedback-detail-full-width';
  }

  ngOnDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
    if (this.overviewSubscription != null) {
      this.overviewSubscription.unsubscribe();
    }
    if ( this.surveysLoadedSubscription != null) {
      this.surveysLoadedSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/feedback.component.ts